// eslint-disable-next-line no-unused-vars
import React from 'react';
import { connect } from 'react-redux';
import { isRoleAdministrator } from '../../data/auth/selectors';

const AdminProtected = ({ isAdmin, children }) => {
    console.log('is_admin', isAdmin);

    if (isAdmin) return children;

    return null;
};

export default connect((state, ownProps) => ({
    ...ownProps,
    isAdmin: isRoleAdministrator(state)
}))(AdminProtected);
